import { BFFAgent } from "BFFAgent";
import {put,call} from 'redux-saga/effects'
import {
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_FAILURE,
} from '../constants';

export function* deleteTakingCarManagementSaga({data}){
  try {

    const {requestsId, stockId,catalogId} = data.data
    const deletedReference = yield call(()=>BFFAgent.Stock.TakingCarManagement.deleteStockCatalogAndStockReference({requestsId, stockId,catalogId}))

    if(deletedReference){
      yield put({
        type: STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_SUCCESS,
        data: deletedReference
      })
    }

  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_FAILURE,
      data: error
    })
  }
}